


import React, { useRef, useState, useEffect } from "react";
import "./VideoSlider.css";

const VideoSlider = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
      videoRef.current.play().catch(() => {});
    }
  }, [isMuted]);

  const toggleSound = () => {
    const muted = !isMuted;
    setIsMuted(muted);

    if (videoRef.current) {
      videoRef.current.muted = muted;
      videoRef.current.play().catch(() => {});
    }
  };

  return (
    <section className="video-slider">

      <video
        ref={videoRef}
        autoPlay
        muted={isMuted}
        loop
        playsInline
        className="slider-video"
      >
        <source src="/images/slider/slider.mp4" type="video/mp4" />
      </video>

      <button
        className="sound-btn"
        onClick={toggleSound}
      >
        {isMuted ? (
          <i className="fas fa-volume-mute"></i>
        ) : (
          <i className="fas fa-volume-up"></i>
        )}
      </button>

    </section>
  );
};

export default VideoSlider;